import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, useColorMode } from 'theme-ui';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { createClient, editClient, getClientById } from '../../../store/actions/client.action';
import theme from '../../../theme';
import { RootState, ClientFormValues } from '../../../../@types';

const AddEditClient: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { clientId } = useParams<{ clientId: string }>();
  const [colorMode] = useColorMode();

  const { clientDetail } = useSelector((state: RootState) => state.client);
  const isEditMode = !!clientId;

  useEffect(() => {
    if (isEditMode) {
      dispatch(getClientById(clientId));
    }
  }, [clientId, isEditMode, dispatch]);

  const validationSchema = useMemo(() => Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
  }), []);

  const initialValues = {
    name: isEditMode ? clientDetail?.name || '' : '',
    email: isEditMode ? clientDetail?.email || '' : '',
  };

  const handleSubmit = async (payload: ClientFormValues) => {
    if (isEditMode) {
      dispatch(editClient({ ...payload, _id: clientId }, () => navigate(-1)));
    } else {
      dispatch(createClient(payload, () => navigate('/client')));
    }
  };

  if (isEditMode && !clientDetail) {
    return <p>Loading...</p>;
  }

  return (
    <div className="main-content px-3" >
      <h1 style={{ color: colorMode === "light" ? "black" : "white" }}>
        {isEditMode ? 'Edit Client' : 'Add Client'}
      </h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-6 mt-4">
                <label htmlFor="name" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.name && touched.name ? 'is-invalid' : ''}`}>Name<span className="text-danger">*</span></label>
                <Field type="text" id="name" name="name" className="form-control" placeholder="Client Name" />
                <ErrorMessage name="name" component="div" className="text-danger" />
              </div>
              <div className="col-md-6 mt-4">
                <label htmlFor="email" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors?.email && touched?.email ? 'is-invalid' : ''}`}>Email ID<span className="text-danger">*</span></label>
                <Field type="text" id="email" name="email" className="form-control" placeholder="Email ID" autoComplete="off" />
                <ErrorMessage name="email" component="div" className="text-danger" />
              </div>
            </div>
            <div className='row mt-5'>
              <div className='col-md-4'></div>
              <div className='col-md-4'>
                <Button type="button" sx={{ border: `1px solid ${theme.colors?.primary || 'defaultBorderColor'}`, background: 'white', color: theme.colors?.muted, borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} onClick={() => navigate(-1)}> Cancel </Button>
              </div>
              <div className='col-md-4'>
                <Button sx={{ borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} type='submit'>Submit</Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  );
};

export default AddEditClient;
